<template>
  <v-container>
    <v-row>
      <v-col justify="center">
        <v-card
          class="mx-auto"
          width="550"
          height="360"
          v-for="(item, index) in cardTest1Items"
          :key="index"
        >
          <v-card-text>
            <p class="primary--text text-subtitle-1 font-weight-medium mb-1">
              {{ item.subtitle }}
            </p>
            <v-divider inset class="mx-0" width="900"></v-divider>
            <v-row class="text--primary mt-3">
              <v-col cols="12">
                {{ item.text }}
              </v-col>
              <v-col cols="12" class="d-flex justify-start">
                <span> Archivo a descargar: {{ coInfoResult.name }}</span>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-row justify="center">
              <v-col cols="4">
                <v-btn
                  color="secundary3"
                  large
                  class="mt-1 text-capitalize"
                  @click.prevent="btnClicked"
                >
                  {{ item.btn }}
                </v-btn>
              </v-col>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'VCardProTestResult1',
  props: ['cardTest1Items', 'coResultDownload', 'btnClicked', 'coInfoResult'],
};
</script>
